import Vue from "vue";
import VueRouter from "vue-router";
const Home = () => import("../views/Home.vue");
const About = () => import("../views/About.vue");
const Campus = () => import("../views/Campus.vue");
const Society = () => import("../views/Society.vue");
const Tab = () => import("../components/Tab.vue");
const TabBar = () => import("../components/TabBar.vue");
const HomeTitle = () => import("../components/HomeTitle.vue");
const StaffItem = () => import("../components/StaffItem.vue");
const Footer = () => import("../components/Footer.vue");
const Details = () => import("../components/Details.vue");
const DetailsSlot = () => import("../components/DetailsSlot.vue");
const User = () => import("../views/User.vue");
const Already = () => import("../components/Already.vue");
const Login = () => import("../components/login.vue");
const Info = () => import("../components/Info.vue");
const Resume = () => import("../components/Resume.vue");
const Chart = () => import("../components/Chart.vue");
const Apply = () => import("../components/Apply.vue");
// 三级
const Personal = () => import("../components/info-tab/Personal.vue");
const Undergo = () => import("../components/info-tab/Undergo.vue");
const Project = () => import("../components/info-tab/Project.vue");
const Education = () => import("../components/info-tab/Education.vue");
const Language = () => import("../components/info-tab/Language.vue");
const Certificate = () => import("../components/info-tab/Certificate.vue");
const Self = () => import("../components/info-tab/Self.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/campus",
    name: "Campus",
    component: Campus,
    meta: {
      title: "校园招聘",
    },
  },
  {
    path: "/society",
    name: "Society",
    component: Society,
    meta: {
      title: "社会招聘",
    },
  },
  {
    path: "/tab",
    name: "Tab",
    component: Tab,
  },
  {
    path: "/tabbar",
    name: "TabBar",
    component: TabBar,
  },
  {
    path: "/hometitle",
    name: "HomeTitle",
    component: HomeTitle,
  },
  {
    path: "/staffitem",
    name: "StaffItem",
    component: StaffItem,
  },
  {
    path: "/footer",
    name: "Footer",
    component: Footer,
  },
  {
    path: "/society/details",
    name: "Details",
    component: Details,
    meta: {
      title: "招聘详情页",
    },
  },

  {
    path: "/campus/details",
    name: "Details",
    component: Details,
    meta: {
      title: "招聘详情页",
    },
  },
  {
    path: "/already/details",
    name: "Details",
    component: Details,
    meta: {
      title: "招聘详情页",
    },
  },
  {
    path: "/detailsSlot",
    name: "DetailsSlot",
    component: DetailsSlot,
  },
  {
    path: "/apply",
    name: "Apply",
    component: Apply,
  },
  {
    path: "/user",
    name: "User",
    component: User,
    meta: { title: "个人信息" },
    children: [
      {
        path: "/",
        redirect: "already",
      },
      {
        path: "already",
        name: "Already",
        component: Already,
      },

      {
        path: "login",
        name: "login",
        meta: { title: "用户登录" },
        component: Login,
      },
      {
        path: "info",
        name: "Info",
        component: Info,
      },
      {
        path: "personal",
        name: "Personal",
        component: Personal,
      },
      {
        path: "resume",
        name: "Resume",
        component: Resume,
      },
      {
        path: "undergo",
        name: "Undergo",
        component: Undergo,
      },
      {
        path: "project",
        name: "Project",
        component: Project,
      },
      {
        path: "education",
        name: "Education",
        component: Education,
      },
      {
        path: "language",
        name: "Language",
        component: Language,
      },
      {
        path: "certificate",
        name: "Certificate",
        component: Certificate,
      },
      {
        path: "self",
        name: "Self",
        component: Self,
      },
    ],
  },
  {
    path: "chart",
    name: "Chart",
    component: Chart,
  },
];

const createRouter = () =>
  new VueRouter({
    routes,
    mode: "history",
  });
// 处理push相同路由问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
// 创建Router对象
const router = createRouter();

// 路由守卫
router.beforeEach((to, form, next) => {
  document.title = to.matched[0].meta.title; //设置title
  next();
});


// 重置Router对象
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
